import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Device } from '@iot-platform/models/i4b';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailPopupModule } from '../../detail-popup/detail-popup.module';
import { DeviceInfoStatusModule } from '../device-info-status/device-info-status.module';

@Component({
  imports: [FlexLayoutModule, InfoDisplayPipe, TranslatePipe, DeviceInfoStatusModule, DetailPopupModule],
  selector: 'iot-platform-ui-device-details-basic-info',
  templateUrl: './device-details-basic-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./device-details-basic-info.component.scss']
})
export class DeviceDetailsBasicInfoComponent {
  device = input<Device | null>(null);
  displayMode = input<'vertical' | 'horizontal' | 'default'>('default');

  selectDevice = output<Device>();
}
